import { render, staticRenderFns } from "./rel-receita-pr.vue?vue&type=template&id=38fb708e&scoped=true&"
import script from "./rel-receita-pr.vue?vue&type=script&lang=js&"
export * from "./rel-receita-pr.vue?vue&type=script&lang=js&"
import style0 from "./rel-receita-pr.vue?vue&type=style&index=0&id=38fb708e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fb708e",
  null
  
)

export default component.exports